/* Delegated events survive Shopify section reloads without duplicate listeners. */
(() => {
  if (window.ccHomeReady) return;
  window.ccHomeReady = true;
  const closeMenus = () => document.querySelectorAll('.cc-mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  const openInquiry = (trigger) => {
    const panel = document.querySelector('#cc-enquiry');
    if (!panel) return false;
    panel.open = true;
    const selected = trigger?.dataset.character;
    const select = panel.querySelector('[name="contact[Character]"]');
    if (selected && select && [...select.options].some(option => option.value === selected)) select.value = selected;
    panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    panel.querySelector('input')?.focus({ preventScroll: true });
    return true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#cc-enquiry' && openInquiry(link)) event.preventDefault();
      if (link.closest('.cc-mobile-menu')) closeMenus();
    }
    const close = event.target.closest('[data-cc-close]');
    if (close) {
      document.querySelector('#cc-enquiry')?.removeAttribute('open');
      document.querySelector('.cc-custom__action a')?.focus();
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(); });
  const sync = () => {
    const panel = document.querySelector('#cc-enquiry');
    if (location.hash === '#cc-enquiry' || document.querySelector('[data-cc-form-result]')) openInquiry();
    else if (panel && !panel.dataset.initialized) panel.open = false;
    if (panel) panel.dataset.initialized = 'true';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true}); else sync();
  window.addEventListener('hashchange', sync);
  document.addEventListener('shopify:section:load', sync);
})();
